export default __webpack_public_path__ + "vendor/ckeditor/skins/moono-lisa/dialog_ie8.css";